document.addEventListener('alpine:init', () => {
  Alpine.data('paymentMethodSingle', () => ({
    sourcesVisible: false,
    activeGroup: 0,

    init() {
      if (this.$root.dataset.grouped === 'true') {
        this.activeGroup = +this.$root.dataset.postId;

        history.replaceState({ postId: this.activeGroup }, document.title, window.location.href);

        if (window.innerWidth <= 787) {
          setTimeout(() => {
            const active = this.$root.querySelector(`.group-tabs a[data-id="${this.activeGroup}"]`);

            if (active) {
              this.$root.querySelector('.group-tabs').scrollLeft = active.offsetLeft - 24;
            }
          });
        }

        addEventListener('popstate', (e) => {
          if (e.state.postId) {
            this.activeGroup = e.state.postId;
          }
        });
      }
    },

    setGroup(postId, title, url) {
      this.activeGroup = postId;
      history.pushState({ postId }, title, url);
    },
  }));
});